export type OrderRequestMessages = {
  orderCreateError: string;
  orderUpdateError: string;
  orderCreateSuccess: string;
  orderUpdateSuccess: string;

  statusDoesNotAllowUpdates: string;
  orderAmountMustNotBeEmpty: string;
  paymentAmountMustBeGreaterThanZero: string;
  paymentsMustEqualOrderAmount: string;
  errorDuringRemovalOrUpdate: string;

  // ITEMS MESSAGES
  successRemoveItemMessage: string;
  errorRemoveItemMessage: string;

  // PAYMENTS MESSAGES
  paymentRemovedSuccess: string;
  paymentRemovedError: string;

  // STATUS VALIDATION MESSAGES
  errorDeliveryDateRequired: string;
  errorInvoiceFieldsRequired: string;
};

export const ORDER_REQUEST_MESSAGES: OrderRequestMessages = {
  orderCreateSuccess: "Pedido criado com sucesso!",
  orderUpdateSuccess: "Pedido atualizado com sucesso!",
  orderCreateError: "Erro na criação do Pedido!",
  orderUpdateError: "Erro ao salvar o Pedido!",

  statusDoesNotAllowUpdates: "Este status não permite atualizações no pedido.",
  orderAmountMustNotBeEmpty: "O valor do pedido deve ser maior ou igual a 1.",
  paymentAmountMustBeGreaterThanZero: "O valor do pagamento deve ser maior ou igual a 1.",
  paymentsMustEqualOrderAmount: "O valor total dos pagamentos deve ser igual ao valor do pedido.",
  errorDuringRemovalOrUpdate: "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.",

  // ITEMS MESSAGES
  successRemoveItemMessage: "Item removido com sucesso!",
  errorRemoveItemMessage: "Falha ao remover o item.",

  // PAYMENTS MESSAGES
  paymentRemovedSuccess: "Pagamento removido com sucesso!",
  paymentRemovedError: "Houve um erro ao remover o pagamento.",

  // STATUS VALIDATION MESSAGES
  errorDeliveryDateRequired: "A data de entrega é obrigatória para o status 'Entregue'.",
  errorInvoiceFieldsRequired: "Os campos de nota fiscal são obrigatórios para o status 'Faturado'.",
};
